module.exports = __webpack_public_path__ + "static/media/cap.23e26b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cap.png
// module id = 659
// module chunks = 0